import encode from '@/utils/encode';
import { LANGUAGE } from '@/interfaces/enum';
import { IStatisticAgentPointListByVendorContentItem } from './statistics';
export const REFRESH_TOKEN = encode('refreshToken', 4);
export const ACCESS_TOKEN = encode('accessToken', 4);
export const FIREBASE_TOKEN = encode('firebaseToken', 4);
export const EXPIRED_AT = 'expired_at';

export enum QUERY_KEYS {
  DASHBOARD = 'dashboard',
  ROLE_LIST = 'role_list',
  GROUP_LIST = 'group_list',
  PROVIDER_LIST = 'provider_list',
  GAME_LIST = 'game_list',
  PROVIDER_ID_LIST = 'provider_id_list',
  VENDOR_CODE_LIST = 'vendor_code_list',
  ANNOUNCEMENT_ADMIN_LIST = 'announcement_admin_list',
  ANNOUNCEMENT_ADMIN_DETAIL = 'announcement_admin_detail',
  ANNOUNCEMENT_DASHBOARD_LIST = 'announcement_dashboard_list',
}

export enum FORMAT_MODELS {
  DATE = 'YYYY-MM-DD HH:mm:ss',
  FULL_DATE = 'YYYY-MM-DD',
}

export const DEFAULT_PAGINATION = {
  page_no: 1,
  page_size: 10,
  agent_name: '',
  sort: 'createdDate.asc',
};

export const backgroundImg = [
  'linear-gradient(180deg, #ff9634, #e76f00)',
  'linear-gradient(180deg,#ffe133,#e6c300)',
  'linear-gradient(180deg,#05f353,#03a839)',
  'linear-gradient(180deg,#01fdfd,#01b1b1)',
  'linear-gradient(180deg,#d497fe,#b54cfd)',
  'linear-gradient(180deg,#9c9c9c,#757575)',
  ' linear-gradient(180deg,#4b92f2,#1168e0)',
  'linear-gradient(180deg,#ff339a,#e60074)',
];

export const validateMeFssage = {
  [LANGUAGE.KR]: {
    required: '아직 입력되지 않음',
  },
  [LANGUAGE.EN]: {
    required: 'is required',
  },
};

export const FORMAT_DATE = 'YYYY-MM-DD HH:mm:ss';

export const DEBOUNCE_TIME = 400;

export const PAGE_NUMBER = 10;

export const MAX_LENGTH_INPUT = 50;

export const OPTIONS_NOTIFICATIONS = [
  { label: 'notifications.announcements', value: 'NOTICE' },
  { label: 'notifications.check', value: 'CHECK' },
  { label: 'notifications.point', value: 'POINT' },
  { label: 'notifications.system_guiding', value: 'GUIDE' },
];

export const IpFilterType = {
  OPEN: 'OPEN',
  WHITELIST: 'WHITELIST',
};

export const PlatformType = {
  BO: 'BACKOFFICE',
  API: 'API',
};

export const SUPER_ADMIN = {
  agent_id: 'admin',
  agent_name: 'super_admin',
};

export const PAYMENT_DEDUCTION_OPTION = {
  PROCESS_AS_BUY_POINT: 'PROCESS_AS_BUY_POINT',
  RETURN_PAYMENT: 'RETURN_PAYMENT',
  NO: 'NO',
};

export const OPERATION_MODE = {
  SEAMLESS: '1',
  TRANSFER: '0',
};

export const PROVIDER_STATUS = {
  INACTIVE: 'inactive',
  ACTIVE: 'active',
};

export const FIRST_ELEMENT = 0;

export const RANGE_DAY_LIMIT = 90;

export const EMPTY_DATA_VENDOR: IStatisticAgentPointListByVendorContentItem = {
  bettingAmountVendor: null,
  cancelAmountVendor: null,
  profitVendor: null,
  vendor: null,
  winAmountVendor: null,
};

export const optionAll = {
  label: 'ALL',
  value: 'ALL',
};

export interface IErrResponse {
  code?: string;
  message?: string;
  success?: boolean;
}

export const ERR_MSG = {
  ERROR_DUPLICATED_BET_LIMIT: 'ERROR_DUPLICATED_BET_LIMIT',
  ERROR_DUPLICATED_PAYOUT_LIMIT: 'ERROR_DUPLICATED_PAYOUT_LIMIT',
  ERROR_NO_PERMISSION_DELETE: 'data.permission.error',
  ERROR_RECORD_NOT_FOUND: 'record.not_found',
  VENDOR_SETTING_UPDATE_STATE: 'vendor_setting.update_state.error',
  INVALID_PARAM_AGENT_ID: 'agent_management.login.invalid_param_agent_id',
  DUPLICATE_AGENT_ID: 'agent_management.create_agent.duplicate_agent_id',
  INVALID_PARAM_AGENT_NAME: 'agent_management.login.invalid_param_agent_name',
  DUPLICATE_AGENT_NAME: 'agent_management.create_agent.duplicate_agent_name',
  PARENT_INVALID: 'agent_management.create_agent.parent_invalid',
  PARENT_NOT_FOUND: 'agent_management.create_agent.parent_not_found',
  ROLE_NOT_FOUND: 'agent_management.create_agent.role_not_found',
  LEVEL_INVALID: 'agent_management.create_agent.level_invalid',
  INVALID_PARAM_AGENT_PASSWORD: 'agent_management.login.invalid_param_agent_password',
  INVALID_FORMAT_AGENT_PASSWORD: 'agent_management.login.agent_password_invalid_format',
  PARENT_DEACTIVATED: 'agent_management.create_agent.parent_deactivated',
  POINT_RATE_INVALID: 'agent_management.create_agent.point_rate_invalid',
  ACCESS_TYPE_INVALID: 'agent_management.create_agent.access_type_invalid',
  WHITE_IP_LIST_INVALID: 'agent_management.create_agent.white_ip_list_invalid',
  BLACK_IP_LIST_INVALID: 'agent_management.create_agent.black_ip_list_invalid',
  OPERATION_MODE_INVALID: 'agent_management.create_agent.operation_mode_invalid',
};

export const ERR_CODE = {
  ERROR_NO_PERMISSION_DELETE_GAME_BET: 'ERROR_NO_PERMISSION_DELETE_GAME_BET',
  ERROR_NO_PERMISSION_DELETE_GAME_PAYOUT: 'ERROR_NO_PERMISSION_DELETE_GAME_PAYOUT',
};

export const URL_PROVIDER_SEARCH = '/adapter-service/providers';
export const URL_PROVIDER_CREATE_V2 = '/adapter-service/providers';
export const URL_PROVIDER_UPDATE_V2 = '/adapter-service/providers';
export const URL_PROVIDER_DELETE = '/adapter-service/providers';
export const URL_VENDOR_CODE_LIST = '/adapter-service/providers/vendor-codes';
export const AGENT_SPECIAL_LIST = ['Bellagio'];

export const MAX_FILES = 10;
export const MAX_IMAGE_BYTES = 10 * 1024 * 1024;
export const MAX_VIDEO_BYTES = 50 * 1024 * 1024;
